export default "__VITE_ASSET__b1bc92d5__"